import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from "classnames";
import { ResponsiveContainer } from "../responsive-container/ResponsiveContainer";
import styles from "./ImageBackgroundContainer.module.scss";
export const ImageBackgroundContainer = ({ children, fullWidth = false, background, mobileBackground = "", withAnimation = false, withBlur, className, }) => {
    const classes = classNames(styles.container, className, {
        [styles.mobile]: mobileBackground,
        [styles.fullWidth]: fullWidth,
        [styles.animated]: withAnimation,
    });
    return (_jsx(ResponsiveContainer, { fullWidth: fullWidth, children: _jsxs("div", { "data-testid": "background-image-container", className: classes, children: [_jsx("div", { className: styles.wrapper, children: _jsx("div", { role: "img", className: classNames(styles.image, { [styles.withBlur]: withBlur }), "aria-label": "background-image", "data-testid": "background-image", style: {
                            "--mobileBackground": `url("${mobileBackground || background}")`,
                            "--background": `url("${background}")`,
                        } }) }), _jsx("div", { className: styles.content, children: children })] }) }));
};
//# sourceMappingURL=ImageBackgroundContainer.js.map